module.exports = __webpack_public_path__ + "static/media/carro_2.1992379b.png";